<template>
  <div>
    <MainMenu :showMenu="showMenu"/>
    <slot></slot>
  </div>
</template>
<script>
import MainMenu from './MainMenu.vue';

export default {
  components: {
    MainMenu,
  },
  computed: {
    showMenu() {
      return this.$route.meta.showMenu;
    },
  },
};
</script>
